import { render } from "./AutoScaleDownPolicyTab.vue?vue&type=template&id=f0f22c0e&scoped=true"
import script from "./AutoScaleDownPolicyTab.vue?vue&type=script&lang=js"
export * from "./AutoScaleDownPolicyTab.vue?vue&type=script&lang=js"

import "./AutoScaleDownPolicyTab.vue?vue&type=style&index=0&id=f0f22c0e&scoped=true&lang=scss"

import exportComponent from "/home/pedro/git/cloudstack/scclouds/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0f22c0e"]])

export default __exports__